import Vue from 'vue'
import { API_URL } from '@/config'

export const persons = {

  namespaced: true,

  state: {
    filters: [
      { column: 'id', label: 'id', options: { type: false }, value: '', status: true },
      { column: 'last_name', label: 'last_name', options: { type: false }, value: '', status: true },
      { column: 'first_name', label: 'first_name', options: { type: false }, value: '', status: true },
    ],
    options: {
      id: { label: 'id', element: 'text' },
      last_name: { label: 'last_name', element: 'text' },
      first_name: { label: 'first_name', element: 'text' },
    },
    presets: [],
    columns: [],
    persons: [],
    sort: {
      column: 'last_name',
      columns: [
        { column: 'last_name', order: 'asc' },
        { column: 'first_name', order: 'asc' },
        { column: 'id', order: 'asc' },
      ],
      order: 'asc'
    },
    total: 0,
    subtotal: 0,
    offset: 0,
  },

  getters: {
    filters: state => state.filters,
    options: state => state.options,
    presets: state => state.presets,
    columns: state => state.columns,
    persons: state => state.persons,
    sort: state => state.sort,
    total: state => state.total,
    subtotal: state => state.subtotal,
    offset: state => state.offset,
  },

  mutations: {
    setFilters(state, filters) { state.filters = filters },
    setOptions(state, options) { state.options = options },
    setPresets(state, presets) { state.presets = presets },
    setColumns(state, columns) { state.columns = columns },
    setPersons(state, persons) { state.persons = state.persons.concat(persons) },
    setSort(state, sort) { state.sort = sort },
    setTotal(state, total) { state.total = total },
    setSubtotal(state, subtotal) { state.subtotal = subtotal },
    setOffset(state, offset) { state.offset = offset },
    clearFilters(state) {
      state.filters = [
        { column: 'id', label: 'id', options: { type: false }, value: '', status: true },
        { column: 'last_name', label: 'last_name', options: { type: false }, value: '', status: true },
        { column: 'first_name', label: 'first_name', options: { type: false }, value: '', status: true },
      ];
      state.options = {
        id: { label: 'id', element: 'text' },
        last_name: { label: 'last_name', element: 'text' },
        first_name: { label: 'first_name', element: 'text' },
      };
    },
    clearList(state) {
      state.persons = [];
      state.total = 0;
      state.subtotal = 0;
      state.offset = 0;
    },
  },

  actions: {

    getOptions: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Person'],
      filter_display: true,
    }}),

    getColumns: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Person'],
      list_display: true,
    }}),

    getPersons: ({ getters }) => Vue.axios.get(API_URL + '/persons', { params: {
      filters: getters.filters,
      offset: getters.offset,
      sorts: getters.sort.columns,
    }}),

    async getList({ state, rootState, getters, commit, dispatch }) {
      const [options, columns, persons] = await Promise.all([
        dispatch('getOptions'),
        dispatch('getColumns'),
        dispatch('getPersons'),
      ])
      .catch(() => {
        commit('setProgress', false, { root: true });
      });

      commit('setProgress', false, { root: true });
      options.data['App\\Models\\Person'].filters.country_id.options = options.data['App\\Models\\Person'].filters.country_id.options.sort((a, b) => rootState._[a.name].localeCompare(rootState._[b.name]));
      commit('setOptions', options.data['App\\Models\\Person'].filters);
      commit('setPresets', options.data['App\\Models\\Person'].presets);
      commit('setColumns', columns.data['App\\Models\\Person']);
      commit('setPersons', persons.data.items);
      commit('setTotal', persons.data.total);
      commit('setSubtotal', persons.data.subtotal);
      commit('setOffset', getters.persons.length);
      state.options.conflict = {
        format: 'wording',
        label: 'conflicts',
        element: 'radio',
        custom: true,
        options: [
          { value: 'has_overlapping_participations', name: 'has_overlapping_participations' },
        ],
      };
      state.options.comment_status = {
        format: 'wording',
        label: 'comment_status',
        element: 'radio',
        custom: true,
        options: [
          { value: 'without', name: 'without' },
          { value: 'ready', name: 'ready' },
          { value: 'open', name: 'open' },
          { value: 'problem', name: 'problem' },
          { value: 'error', name: 'error' },
        ],
      };
    },

    async addPersons({ getters, commit, dispatch }) {
      const persons = await dispatch('getPersons');
      commit('setProgress', false, { root: true });
      commit('setPersons', persons.data.items);
      commit('setOffset', getters.persons.length);
    },

    async sortPersons({ rootState, commit, dispatch, getters }, data) {
      if (!rootState.progress) {
        let order = getters.sort.column === data.column 
          ? getters.sort.order === 'asc' ? 'desc' : 'asc'
          : 'asc';
        let columns = data.columns.reduce((carry, column) => { 
          carry.push({ column: column, order: order });
          return carry;
        }, []);
        commit('setSort', { column: data.column, columns: columns, order: order });
        commit('clearList');
        await dispatch('getList');
      }
    }

  }

}
